import React, { FormEvent } from "react";
import styles from "./AdBeingWell.module.scss";

function AdBeingWell() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.textBody}>
        <div className={styles.highlight}>Featured Highlights</div>
        <h1 className={styles.title}>
          Introducing our new High School Program:
        </h1>
        <h1 className={styles.secondaryTitle}>
          <strong>BEING WELL</strong>
          <br />
          MATTERS™
        </h1>
        <p className={styles.description}>
          Empowering students to build<br />healthy habits
        </p>
      </div>
    </div>
  );
}

export default AdBeingWell;
